(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/suspension-message/assets/javascripts/suspension-message.js') >= 0) return;  svs.modules.push('/components/components/suspension-message/assets/javascripts/suspension-message.js'); (function(svs) {
  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.suspension_message = svs.components.suspension_message || {};
  var logger = svs.core.log.getLogger('components:suspension-message');
  function showSuspensionEndMessage(callback) {
    var options = {
      method: 'GET',
      path: '/player/suspensionhistory?count=1&key=0'
    };
    var successFn = function(response) {
      if (svs.core.detect.tenant('tb')) {
        response.suspensions = response.suspensions.filter(function(value) {
          if (value.product.toUpperCase() === 'POKER') {
            return false;
          }
          return true;
        });

        if (response.suspensions.length === 0) {
          callback();
          return;
        }
      }

      showDialog(
        svs.components.suspension_message.templates.end_message(response),
        callback
      );
    };
    var errorFn = function() {
      showDialog(
        svs.components.suspension_message.templates.end_message(),
        callback
      );
    };
    svs.core.jupiter.call(options, successFn, errorFn);
  }

  function showSuspensionMessage(callback) {
    var options = {
      method: 'GET',
      path: '/player/suspensions'
    };
    var successFn = function(response) {
      response.suspensions.sort(function(a, b) {
        if (a.isTerminable === b.isTerminable) {
          return 0;
        } else if (a.isTerminable) {
          return 1;
        }
        return -1;

      });

      if (svs.core.detect.tenant('tb')) {
        response.suspensions = response.suspensions.filter(function(value) {
          if (value.product.toUpperCase() === 'POKER') {
            return false;
          }
          return true;
        });

        if (response.suspensions.length === 0) {
          callback();
          return;
        }
      }

      var message = svs.components.suspension_message.templates.message(
        response
      );
      if (message.length > 0) {
        showDialog(message, callback, svs.components.Alert.Time.LONG);
      } else {
        logger.error(
          'Got suspension notification but no suspensions from api.'
        );
        errorFn();
      }
    };
    var errorFn = function() {
      var message =
        'Du har en spelpaus aktiv.<br>Läs mer <a href="' +
        svs.core.urlMapping.get('gamingResponsibilityPause') +
        '">här</a>';
      showDialog(message, callback);
    };
    svs.core.jupiter.call(options, successFn, errorFn);
  }

  function showDialog(message, callback, time) {
    if (svs.core.detect.feature('ft-new-dialog')) {
      var dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.TUR,
        icon: 'spelpaus',
        type: svs.components.dialog.type.CONFIRM,
        allowDimmerClick: false,
        title: 'Spelpaus',
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: message
          }
        ],
        actions: [
          {
            title: 'Ok',
            callback: callback
          }
        ]
      });
      svs.components.dialog.api.add(dialog);
    } else {
      new svs.components.Alert(message, time ? { time: time } : {}).show(
        callback
      );
    }
  }

  svs.components.suspension_message.showSuspensionMessage = showSuspensionMessage;
  svs.components.suspension_message.showSuspensionEndMessage = showSuspensionEndMessage;
})(svs);

 })(window);